import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';

import {
  Button,
  Container,
  SuccessMessage,
} from '../../common/form';

import { propTypes, defaultProps } from '../prop-types';
import useContentFormatTypeStore from './state-hook';
import {
  createContentFormatType,
  updateContentFormatType,
} from '../../../../services/lwadmin/content-format-type/content-format-type-service';

import withNameInput from '../../common/input';

const Name = withNameInput('contentFormatType', 'name', useContentFormatTypeStore);
const Slug = withNameInput('contentFormatType', 'slug', useContentFormatTypeStore);
const Description = withNameInput('contentFormatType', 'description', useContentFormatTypeStore);

const SContainer = styled(Container)`
  padding-bottom: 40px;
`;

export default function Form(props) {
  const [saving, setSaving] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const set = useContentFormatTypeStore(state => state.set);
  const contentFormatType = useContentFormatTypeStore(state => state.contentFormatType);
  const { id } = contentFormatType;

  useChangeAwareEffect(({ isMount }) => {
    isMount && set(state => {
      state.contentFormatType = (props || defaultProps).contentFormatType;
    });
  }, {});

  const saveContentFormatType = e => {
    e && e.preventDefault();

    setSaving(true);

    const payload = {
      name: contentFormatType.name,
      slug: contentFormatType.slug,
      description: contentFormatType.description,
    };

    const createOrUpdate = id
      ? updateContentFormatType(id, payload)
      : createContentFormatType(payload);

    createOrUpdate.then(resp => {
      setSaving(false);
      setShowSuccessMessage(true);

      const createdId = _.get(resp, 'data.id');
      if (createdId) {
        set(state => {
          state.contentFormatType.id = createdId;
        });
      }

      set(state => {
        state.errors = {};
      });
    }).catch(error => {
      setSaving(false);
      setShowSuccessMessage(false);

      set(state => {
        state.errors = _.get(error, 'response.data', {});
      });

      setSaving(false);
    });
  };

  return (
    <SContainer>
      {showSuccessMessage && (
        <SuccessMessage>
          Content Format Type successfully saved
        </SuccessMessage>
      )}
      <Name />
      <Slug />
      <Description />
      <Button className="btn btn-primary" onClick={saveContentFormatType} disabled={saving}>
        {saving ? 'Saving' : 'Save'}
      </Button>
    </SContainer>
  );
}

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
